import { createDDSClient } from "@aelive/dds-client";

export const dds = createDDSClient({
  http: { url: process.env.REACT_APP_DDS_HTTP_URL },
  ws: { url: process.env.REACT_APP_DDS_WS_URL }
});

/**
 * dds.searchData resolves { list, meta }. Shared here rather than duplicated
 * per caller (TXLivePage.jsx and useCisMatchData.js both had their own
 * identical copy) so a change to the response shape only needs one edit.
 */
export const getSearchList = (res) => (Array.isArray(res?.list) ? res.list : []);